import {Component, OnInit, AfterViewInit, Input} from '@angular/core';
import {trigger, style, animate, transition, query, stagger, keyframes, state, group} from '@angular/animations';
import {CommonService} from '../common.service';
import {ApiService} from '../api.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AbilityConfig} from '../ability-config/ability-config';
import {PlatformLocation} from '@angular/common';
import {CasePracticeComponent} from '../case-practice.component';
import {TokenService} from '../tokenService.service';

@Component({
  selector: 'app-case-practice-coach-report',
  animations: [
    trigger('bestPathBoxAnimation', [
      state('hideBestPathBox', style({opacity: 0, transform: 'scale(0, 0)'})),
      state('showBestPathBox', style({opacity: 1, transform: 'scale(1, 1)'})),
      transition('hideBestPathBox => showBestPathBox', animate('200ms', keyframes([
          style({transform: 'scale(0.1, 0.1)', opacity: 0.1}),
          style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
          style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
          style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
          style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
          style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
          style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
          style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
          style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
          style({transform: 'scale(1, 1)', opacity: 1})
        ]))
      ),
      transition('showBestPathBox => hideBestPathBox', animate('200ms', keyframes([
          style({opacity: 1}),
          style({opacity: 0})
        ]))
      )
    ]),
    trigger('analysisBoxAnimation', [
      state('hideAnalysisBox', style({opacity: 0, transform: 'translate(-100%)'})),
      state('showAnalysisBox', style({opacity: 1})),
      transition('hideAnalysisBox => showAnalysisBox', animate('200ms', keyframes([
          style({
            transform: 'matrix3d(0.08700000000000001,-0.09,0.50,0,0.09,0.01,0.00,0,-0.5,0,0.87,0,0,0,0.01,1) translate(0, -50%)',
            opacity: 1, left: 0, top: '45%'
          }),
          style({
            transform: 'matrix3d(0.43065,-0.12,0.50,0,0.12,0.2475,0.00,0,-0.5,0,0.87,0,0,0,0.01,1) translate(0, -50%)',
            opacity: 1, left: 0, top: '47%'
          }),
          style({
            transform: 'matrix3d(0.6525,-0.07,0.50,0,0.07,0.6,0.00,0,-0.5,0,0.87,0,0,0,0.01,1) translate(0, -50%)',
            opacity: 1, left: 0, top: '49%'
          }),
          style({
            transform: 'matrix3d(1,0,0.00,0,0.00,1,0.00,0,0,0,1,0,0,0,0,1) translate(0, -50%)',
            opacity: 1, left: 0, top: '50%'
          })
        ])
        )
      ),
      transition('showAnalysisBox => hideAnalysisBox', animate('500ms', keyframes([
        style({opacity: 1}),
        style({opacity: 0})
      ])))
    ]),
    trigger('starAnimation', [
      state('hideStar', style({opacity: 0})),
      state('showStar', style({opacity: 1})),
      transition('hideStar => showStar', [
        style({opacity: 1}),
        query('.starReport', style({opacity: 0})),
        query('.starReport5', animate('200ms', style({opacity: 1})), {optional: true}),
        query('.starReport4', animate('200ms', style({opacity: 1})), {optional: true}),
        query('.starReport3', animate('200ms', style({opacity: 1})), {optional: true}),
        query('.starReport2', animate('200ms', style({opacity: 1})), {optional: true}),
        query('.starReport1', animate('200ms', style({opacity: 1})), {optional: true})
      ])
    ])
  ],
  templateUrl: './case-practice-coach-report.component.html',
  styleUrls: ['./case-practice-coach-report.component.css',]

})
export class CasePracticeCoachReportComponent implements OnInit, AfterViewInit {

  currentName: any;
  currentTotal: any;
  currentDescription: any;
  currentAnalysis: any;

  learningPathId: any;
  exerciseMetaId: any;
  practiceMetaId: any;
  userId: any;
  cardId: any;

  //报告等级KA对象：传递给等级组件
  reportKAData: any;
  // 是否显示等级组件：用于异步渲染判断
  isShowReportLv: boolean = false;
  //二级标识，用于判断接口返回正常不正常：正常显示组件，不正常隐藏组件
  targetShow: any;

  // chuanjie: any;
  learningPathMetaId: any;
  learningPath: any;
  learningTour: any;
  finished: boolean;
  analysisBoxShow: boolean;
  bestPathBoxShow: boolean;
  starShow: boolean;
  reportName: string = '辅导';

  exerciseTutor: any;
  tutor: any;
  optimum: any;

  mode: number;
  lvCls: string;

  // 皮肤样式
  skinColor: string = 'Pink';


  starPicUrl: string;

  pathClickable: boolean;
  goToListClickedStatus: boolean;
  redoClickedStatus: boolean;
  assetsRoute: string = '../../assets';

  itemClickEnable: boolean = false;
  //配置信息
  abilityConfig: AbilityConfig;

  //当前用户获得的KA
  userKA: any;

  //KaAnalysis
  KaAnalysis: any;
  practiceList: any;
  //报告
  report: any;
  isOpenClass: number = 0;
  type : string //是否为pc横版
  constructor(private commonService: CommonService,
              private apiService: ApiService,
              private route: ActivatedRoute,
              private platformLocation: PlatformLocation,
              private tokenService: TokenService,
              private router: Router) {
  }

  ngOnInit() {
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    this.abilityConfig = new AbilityConfig(this.apiService,this.commonService);
    this.bestPathBoxShow = false;
    this.analysisBoxShow = false;
    this.starShow = false;
    this.pathClickable = true;
    this.goToListClickedStatus = false;
    this.redoClickedStatus = false;

    this.route.queryParams.subscribe(queryParams=>{
     this.type=queryParams['type']
    })
    this.route.params.subscribe(params => {
      this.cardId = params['cardId'];
      this.exerciseMetaId = params['exerciseMetaId'];
      let isOutLink = Number(params['isOutLink']);
      this.practiceMetaId = {60503:605}[this.exerciseMetaId];

      if(this.platformLocation['location']['href'].indexOf('isShowBack') > -1 || isOutLink === 1){
        localStorage.setItem('openClass','1');
      }else{
        localStorage.removeItem('openClass');
      }
      this.isOpenClass = Number(localStorage.getItem("openClass")) ? 1 : 0;


      this.getLearningTour().then(result=>{
        this.userId = result.user_id;
      }).then(()=>{
        return this.createAndGetPracticeList(this.exerciseMetaId, this.userId).then(result=>{
          return this.practiceList = result;
        })
      }).then(()=>{
        return this.getLearningPathMetaId(this.practiceList.learningPathId).then(result => {
          return this.learningPathMetaId = result.data;
        })
      }).then(() => {
        return this.getExerciseTutor(this.exerciseMetaId).then(result => {
          return this.exerciseTutor = result;
        });
      }).then(() => {
        return this.getKAStar(this.cardId).then(result => {
          return this.userKA = result;
        });
      }).then(() => {
        return this.getKAAnalysis(this.exerciseMetaId).then(result => {
          return this.KaAnalysis = result;
        });
      }).then(() => {
        $('#userIdContainer').val(this.userId);
        $('#learningPathMetaIdContainer').val(this.learningPathMetaId);
        this.report = this.handleKaReport(this.userKA, this.KaAnalysis);
        this.mode = 4;
        this.starPicUrl = '/casepracticecoach/star_report.png';
        this.tutor = this.exerciseTutor.tutor;
        this.optimum = this.exerciseTutor.optimum;
        this.reportKAData = this.setPracticeLevelDictionary(this.userKA);
        this.lvCls = this.reportKAData ? this.lvCls = this.mode + ' bgBlur' : this.lvCls = this.mode + '';
        this.isShowReportLv = this.lvCls.indexOf('bgBlur') === -1 ? false : true;
        setTimeout(() => {
          this.itemClickEnable = true;
        }, 500);
      });
    });
  }

  ngAfterViewInit() {
    let that = this;
    this.commonService.initPage({
      'backgroundColor': 'white'
    });
    $(document).ready(function () {
      var listenerTimeout = setInterval(function () {
        var bestPathEle = document.getElementById('bestPathBox'),
          analysisEle = document.getElementById('analysisContent'),
          tutorEle = document.getElementById('tourReviewBox');
        if (bestPathEle !== null && analysisEle !== null && tutorEle != null) {
          bestPathEle.addEventListener('scroll', that.onBestPathScroll);
          analysisEle.addEventListener('scroll', that.onAnalysisScroll);
          tutorEle.addEventListener('scroll', that.onTutorScroll);
          clearInterval(listenerTimeout);
        }
      }, 500);
    });
  }

  //关闭
  close() {
    this.apiService.getOrCreateLearningPath(String(this.learningPathMetaId)).subscribe(result=>{
      //转向情景列表
      console.log(this.practiceMetaId);
      let link = this.abilityConfig.getPracticeLinkList(result.name, this.practiceList.learningPathId, this.practiceMetaId);
      if (link.length > 0 && this.isOpenClass === 0) {
        if(this.type){
          this.router.navigate([result.id,this.practiceMetaId,'case-practice'],{queryParams:{type:'huatek'}});
        }else{
          this.router.navigate([result.id,this.practiceMetaId,'case-practice']);
        }

      }else{
        if(this.type){
          this.router.navigate(['egret-practice-communicate',60503],{queryParams:{type:'huatek'}});
        }else{
          this.router.navigate(['egret-practice-communicate',60503]);
        }

      }
    });
  }

  createAndGetPracticeList(exerciseMetaId, userId){
    return this.apiService.ajax({
      'type': 'GET',
      'url': '/sim/v1/simulation/' + exerciseMetaId +'/createAndGet'
      // 'url': this.commonService.getOrigin()+'/sim/v1/simulation/' + exerciseMetaId +'/createAndGet?userId='+userId
    }).toPromise();
  }


  onBestPathScroll() {
    var overlay = document.getElementById('bestPathBox');
    if (overlay.scrollTop < 1) {
      overlay.scrollTop = 1;
    } else if (overlay.scrollHeight - overlay.scrollTop - overlay.clientHeight < 1) {
      overlay.scrollTop = overlay.scrollTop - 1;
    }
  }

  onAnalysisScroll() {
    var overlay = document.getElementById('analysisContent');
    console.log('scroll1');
    if (overlay.scrollTop < 1) {
      overlay.scrollTop = 1;
    } else if (overlay.scrollHeight - overlay.scrollTop - overlay.clientHeight < 1) {
      overlay.scrollTop = overlay.scrollTop - 1;
    }
  }

  onTutorScroll() {
    var overlay = document.getElementById('tourReviewBox');
    if (overlay.scrollTop < 1) {
      overlay.scrollTop = 1;
    } else if (overlay.scrollHeight - overlay.scrollTop - overlay.clientHeight < 1) {
      overlay.scrollTop = overlay.scrollTop - 1;
    }
  }

  subWrapOneOut() {
    $('#subWrapOne').fadeOut(function () {
      $('#subWrapTwo').fadeIn();
      $('#btnWrap').fadeIn();
    });
  }

  tourReviewBoxIn() {
    $('#tourReviewShade').fadeIn();
    $('#tourReviewBox').fadeIn();
    $('.closeBtn' + this.skinColor).fadeIn();
    this.pathClickable = false;
  }

  tourReviewBoxOut() {
    $('#tourReviewShade').fadeOut();
    $('#tourReviewBox').fadeOut();
    $('.closeBtn' + this.skinColor).fadeOut();
    this.pathClickable = true;
  }

  bestPathIn() {
    if (!this.pathClickable) {
      return;
    }
    $('.closeBtn' + this.skinColor).fadeIn();
    this.bestPathBoxShow = true;
    $('#shade').fadeIn();
  }

  bestPathOut() {
    $('.closeBtn' + this.skinColor).fadeOut();
    this.bestPathBoxShow = false;
    $('#shade').fadeOut();
  }


  //操作拼接报告
  handleKaReport(userKA, KaAnalysis) {
    let report = [];

    if(userKA.length !== KaAnalysis.length){
      let id = [];
      for(let i = 0, len = userKA.length; i < len; i += 1){
        id.push(userKA[i].simulationKaId);
      }
      report = KaAnalysis.filter(item => id.indexOf(item.id) > -1);
      let deselectedItem = this.findDeselectedItem(report,KaAnalysis);
      if(deselectedItem.length){
        for(let i = 0 ,len = deselectedItem.length; i<len; i+=1){
          userKA.push(deselectedItem[i]);
        }
      }else{
        userKA.push(deselectedItem);
      }

    }else{
      userKA = userKA;
    }

    console.log(userKA);
    for (let i = 0, len = userKA.length; i < len; i += 1) {
      report[i] = {};
      report[i]['id'] = KaAnalysis[i]['id'];
      report[i]['name'] = KaAnalysis[i]['name'];
      report[i]['value'] = userKA[i]['star'] ? userKA[i]['star'] : 1;
      report[i]['description'] = KaAnalysis[i]['description'];
      report[i]['analysis'] = KaAnalysis[i]['analysis' + report[i]['value']];
    }
    return report;
  }


  // 比对缺少的项
  findDeselectedItem(currentArray, previousArray) {
    for(let i = 0, len = previousArray.length; i<len; i+=1) {
      if (currentArray.indexOf(previousArray[i]) == -1)
        return previousArray[i];
    }
    return null;
  }



  //获取learningTour
  getLearningTour() {
    return this.apiService.ajax({
      'type': 'get',
      'url': '/sr/learningtournew'
    }).toPromise();
  }

  //获取优秀示范
  getExerciseTutor(exerciseMetaId) {
    return this.apiService.ajax({
      'type': 'get',
      'url': '/sr/exerciseTutor/' + this.exerciseMetaId
    }).toPromise();
  }

  //获取KAAnalysis
  getKAAnalysis(exerciseMetaId) {
    return this.apiService.ajax({
      'type': 'get',
      'url': '/sim/v1/simulation/multiExerciseMetas/' + exerciseMetaId + '/getKaAnalysis'
      // 'url': this.commonService.getOrigin() + '/sim/v1/simulation/multiExerciseMetas/' + exerciseMetaId + '/getKaAnalysis'
    }).toPromise();
  }

  //获取learningPathMetaId
  getLearningPathMetaId(learningPathId) {
    return this.apiService.ajax({
      'type': 'get',
      'url': '/ddilearner/v1/getLearningPathMetaId/' + learningPathId
    }).toPromise();
  }


  //重做
  redo() {
    if (!this.pathClickable || this.redoClickedStatus) {
      return;
    } else {
      this.redoClickedStatus = true;
    }

    let channel = document.getElementById('resource_route');
    let origin = channel.dataset.src === ''? this.commonService.getOrigin() : 'https://m.transtalent.cn';
    let params = channel.dataset.src === ''? '' : '&channelHost='+this.commonService.getOrigin()+'/yyddi/';
    this.createNewCard(this.exerciseMetaId, this.userId).then(() => {
      let originUrl = origin + '/coach/' + this.exerciseMetaId + '/index.html?userId=' + this.userId + '&learningPathMetaId=' + this.learningPathMetaId + '&simulationId=' + this.exerciseMetaId + '&learningPathId=' + this.practiceList.learningPathId + '&practiceMetaId=' + this.practiceMetaId  + '&token=' + this.tokenService.findToken() + '&userIdEncoder=' + this.tokenService.findUserIdEncoder();
      this.platformLocation['location']['href'] = this.isOpenClass === 1 ? originUrl + '&isShowBack=0'  : this.type === 'huatek' ? originUrl+'&type=huatek' : originUrl+params;
    });


  }

  //获取KA Star
  getKAStar(cardId) {
    return this.apiService.ajax({
      'type': 'GET',
      'url': '/sim/v1/simulation/card/' + cardId + '/getKaStar'
      // 'url': this.commonService.getOrigin() + '/sim/v1/simulation/card/' + cardId + '/getKaStar'
    }).toPromise();
  }

  //创建新的流水卡
  createNewCard(exerciseMetaId, userId) {
    return this.apiService.ajax({
      'type': 'POST',
      'url': '/sim/v1/simulation/' + exerciseMetaId + '/card'
      // 'url': this.commonService.getOrigin() + '/sim/v1/simulation/' + exerciseMetaId + '/card?userId=' + userId
    }).toPromise();
  }

  analysisBoxIn(i) {
    if (!this.itemClickEnable) {
      return false;
    }
    let _this = this;
    this.currentName = this.report[i].name;
    this.currentDescription = this.report[i].description;
    this.currentTotal = this.report[i].value;
    this.currentAnalysis = this.report[i].analysis;
    $('#analysisShade').fadeIn();
    // 滚动到订端
    $('#analysisContent').scrollTop(0);
    // $('#analysisBox').fadeIn();
    this.analysisBoxShow = true;
    $('body').css('overflow-y', 'hidden');
    setTimeout(function () {

      _this.starShow = true;

    }, 300);

    this.pathClickable = false;

    document.getElementById('analysisShade').ontouchmove = function (e) {
      e.preventDefault();
    };
    document.getElementById('analysisHead').ontouchmove = function (e) {
      e.preventDefault();
    };
    document.getElementById('closeBtn3').ontouchmove = function (e) {
      e.preventDefault();
    };

  }

  analysisBoxOut() {

    $('#analysisShade').fadeOut();
    this.analysisBoxShow = false;
    $('body').css('overflow-y', 'scroll');
    this.starShow = false;
    this.pathClickable = true;

  }

  // 返回列表
  goToList() {
    if (this.goToListClickedStatus) {
      return;
    } else {
      this.goToListClickedStatus = true;
    }

    this.close();

  }

  //设置等级参数
  setPracticeLevelDictionary(userKA) {
    console.log(userKA)
    let finalScore = 0;
    userKA.forEach((v) => {
      v['star'] = v['star'] ? v['star'] : 0;
      finalScore += v['star'];
    }, 0);

    //计算等级
    let level = (finalScore <= 9 && 1) || (finalScore <= 20 && finalScore >= 10 && 2) || (finalScore <= 34 && finalScore >= 21 && 3) || (finalScore >= 35 && 4) || 0;
    //计算description
    let description = {
      1: '额…有点失落？没关系，看看优秀示范，再试一次吧！',
      2: '距离优秀还有一步，查看报告，再来一次吧！',
      3: '离完美就差一点，要不要再试一次？',
      4: '近乎完美的一场辅导讨论，优秀如你！'
    }[level] || '错误的等级，无法获取相应的description';

    return {
      'level': level,
      'description': description
    };
  }

  //进入后测
  linkToPostSurvey() {
    this.apiService.getOrCreateLearningPath(this.learningPathMetaId).subscribe(result => {
      this.learningPath = result;
      if (this.learningPath.subItems.length == 3) {

        this.getLearningTour().then(result => {
          this.learningTour = result;
          let link = ['survey', this.learningTour.tour_id, 3, 2];
          this.router.navigate(link);
        });
      } else {
        let link = ['survey', this.learningPath.id, this.learningPath.subItems[4].surveyMetaId, 1];
        this.router.navigate(link);
      }
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/case-practice-coach-report/case-practice-coach-report.component.ts